

import { all, call, put, take, takeEvery, takeLatest } from 'redux-saga/effects'
import * as api from '../services/api'
import { cloneDeep } from '../modules/utilities'

const initialState = {
  advisers: null,
  synced: false,
}

export function reducer(state = initialState, action) {

  switch (action.type) {

    case 'advisers.get':
      return {
        ...state,
      }

    case 'advisers.set': {
      return {
        ...state,
        advisers: action.advisers,
        synced: action.synced ?? false,
      }
    }

    default: {
      return state
    }
  }
}

function* handleGetAdvisers() {
  const advisers = yield call(api.advisers.getAdvisers)
  yield put(actions.setAdvisers({ advisers }))
}

function* handleSetIsFavouriteById({ advisers, _id, isFavourite }) {
  if (advisers) {
    const updated = advisers.map(a => (a.id === _id || a.companyNumber === _id) ? { ...a, isFavourite } : a)
    yield put(actions.setAdvisers({ advisers: updated, synced: true }))
  }
}

function* handleUpdateIsFavourite({ advisers, favourites }) {
  if (advisers && favourites) {
    const updated = cloneDeep(advisers)
    favourites.companies.forEach(company => {
      const adviser = updated.find(a => a.companyNumber === company._id || a.id === company._id)
      if (adviser) adviser.isFavourite = true
    })
    yield put(actions.setAdvisers({ advisers: updated, synced: true }))
  }
}

// #region actions, selectors and sagas
export const actions = {
  getAdvisers: () => ({ type: 'advisers.get' }),
  setAdvisers: props => ({ type: 'advisers.set', ...props }),
  setIsFavouriteById: (advisers, _id, isFavourite) =>
    ({ type: 'advisers.setIsFavouriteById', advisers, _id, isFavourite }),
  updateIsFavourite: (advisers, favourites) =>
    ({ type: 'advisers.updateIsFavourite', advisers, favourites }),
}

export const selectors = {}

export function* sagas() {
  yield all([
    takeLatest('advisers.get', handleGetAdvisers),
    takeEvery('advisers.setIsFavouriteById', handleSetIsFavouriteById),
    takeEvery('advisers.updateIsFavourite', handleUpdateIsFavourite),
  ])
}
// #endregion

